/* eslint-disable @typescript-eslint/no-magic-numbers */
import { CityViewModel } from '../model/location/cityViewModel';

export const getCityRegionId = (city: Pick<CityViewModel, 'regionId'>): number | undefined => {
  if (city.regionId === 30) {
    // Moscow
    return 31;
  } else if (city.regionId === 63) {
    // Saint-Petersburg
    return 27;
  }

  return city.regionId;
};
